export const borrowingBaseCertificateConstants = {
  UPDATE_FORM_DATA: 'UPDATE_FORM_DATA',
  CLEAN_FORM_DATA: 'CLEAN_FORM_DATA',
  CLEAN_UPLOADED_DOCUMENT: 'CLEAN_UPLOADED_DOCUMENT',
  UPLOAD_DOCUMENT_REQUEST: 'UPLOAD_DOCUMENT_REQUEST',
  UPLOAD_DOCUMENT_SUCCESS: 'UPLOAD_DOCUMENT_SUCCESS',
  UPLOAD_DOCUMENT_FAILURE: 'UPLOAD_DOCUMENT_FAILURE',
  SET_ID: 'SET_ID',
}
